import { SheetFooter } from '@/components/ui/sheet'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { MEASUREMENT_GUIDES } from '../../../../../../lib/constants/size'

export const GuideContent = ({ sizeChart }: { sizeChart: string }) => {
  const sizeChartData = MEASUREMENT_GUIDES[sizeChart]
  const t = useTranslations()

  return (
    <div className='h-full'>
      <video
        className='w-full rounded-lg'
        loop
        playsInline
        muted
        autoPlay
        height={265}
        width={519}
      >
        <source src={sizeChartData.video.url}></source>
      </video>

      <ul className='mt-6 space-y-4'>
        {sizeChartData.steps.map((step, index) => (
          <li key={index} className='flex items-start gap-2'>
            <Image
              src={ImageHelper.getImageUrl(step.image, '', 144)}
              alt='guild'
              width={72}
              height={72}
              className='rounded-lg'
              loading='lazy'
            />
            <div>
              <p className='mb-1 font-criteria text-sm font-semibold uppercase leading-5 text-gray-900'>
                {t(step.title)}
              </p>
              <p className='font-sans text-sm leading-5 text-neutral-600'>
                {t(step.description)}
              </p>
            </div>
          </li>
        ))}
      </ul>
      {/* <Button variant='black' className='mt-4'>
        Tính toán
      </Button> */}
    </div>
  )
}

export const GuildContentFooter = ({ sizeChart }: { sizeChart: string }) => {
  const sizeChartData = MEASUREMENT_GUIDES[sizeChart]
  const t = useTranslations()
  return (
    <SheetFooter className='flex flex-col gap-y-4 bg-neutral-200 px-15 py-10.5 md:flex-row md:justify-start'>
      <ul className='list-decimal space-y-6'>
        {sizeChartData.measurementPoints.map((point, index) => (
          <li
            key={index}
            className='font-sans text-sm font-bold leading-4.5 text-neutral-800 opacity-90'
          >
            {t(point.title)}
            <p className='font-normal'>{t(point.description)}</p>
          </li>
        ))}
      </ul>
      <Image
        src={ImageHelper.getImageUrl(sizeChartData.illustration, '', 504)}
        alt='Measurement guide illustration'
        width={252}
        height={283}
        unoptimized
        loading='lazy'
      />
    </SheetFooter>
  )
}
